module.exports = __webpack_public_path__ + "static/img/blog 768x1024.cc26a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/blog/blog 768x1024.jpg
// module id = oDYO
// module chunks = 47